import { AllUsers } from '@/components/user/AllUsers';

export default function Users() {
	return (
		<div className="flex items-center h-full py-6 flex-col">
			<AllUsers />
		</div>
	);
}
